var map = {
	"./arrow-down-icon.svg": 552,
	"./call-of-duty-infinite-warfare.png": 427,
	"./call-of-duty-wwii.png": 521,
	"./cart-icon.svg": 285,
	"./checkout-img.jpg": 869,
	"./fifa-18.png": 263,
	"./horizon-zero-dawn.png": 600,
	"./img-background.svg": 442,
	"./mortal-kombat-xl.png": 182,
	"./shards-of-darkness.png": 893,
	"./super-mario-odyssey.png": 734,
	"./terra-media-sombras-de-mordor.png": 864,
	"./the-witcher-iii-wild-hunt.png": 863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;